import { render, staticRenderFns } from "./ElectricityContractBox.vue?vue&type=template&id=7f4d716c&"
import script from "./ElectricityContractBox.vue?vue&type=script&lang=ts&"
export * from "./ElectricityContractBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports